export enum GroupTaskModalContextDispatchActionType {
	SetModalGroup,
	SetModalTask,
	SetModalDayOffset,
	CloseGroupTaskModal,
}
